"use client";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useEffect } from "react";
import { X } from "lucide-react";
import clsx from "clsx";

import { ToastDataType } from "@/app/context/toast-context";

const variantMap: Record<string, "default" | "destructive"> = {
  success: "default",
  warning: "default",
  danger: "destructive",
  error: "destructive",
};

const colorMap: Record<string, string> = {
  success: "!bg-success !text-white !border-success",
  warning: "!bg-warning !text-black !border-warning",
  danger: "!bg-error !text-white !border-error",
  error: "!bg-error !text-white !border-error",
};

export const Toast = ({
  toast,
  onRemove,
}: {
  toast: ToastDataType;
  onRemove: (_: string) => void;
}) => {
  useEffect(() => {
    const timer = setTimeout(() => onRemove(toast.id), toast.duration || 5000);

    return () => clearTimeout(timer);
  }, [toast, onRemove]);

  return (
    <div className="z-10 mt-4 flex w-full items-center">
      <Alert
        variant={variantMap[toast?.type || "default"] || "default"}
        className={clsx("relative", colorMap[toast?.type])}
      >
        <AlertDescription className={clsx(colorMap[toast?.type])}>{toast.message}</AlertDescription>
        <button
          onClick={() => onRemove(toast.id)}
          className="absolute right-2 top-2 cursor-pointer hover:opacity-70"
        >
          <X className="h-4 w-4" />
        </button>
      </Alert>
    </div>
  );
};
